import { useSearchParams } from "next/navigation";

export const useGetIsFormReadyModalOpen = () => {
  const search = useSearchParams();
  return Boolean(search.get("isFormReadyModalOpen") || undefined);
};
